const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

let headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
};

// Get Voice Command list api
const getVoiceCommandApi = async (
    accessToken: string, // access token
    websiteId:string
): Promise<any> => {
    //get api list

    const url = `${baseURL}/voice-command/list/${websiteId}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

const AddVoiceCommandApi = async (
  website_id: string,
  command_title: string,
  description: string,
  command_value: string,
  accessToken?: string // access token
): Promise<any> => {
    
  const formData = new FormData();
  formData.append('website_id', website_id)
  formData.append('command_title', command_title)
  formData.append('command_value', command_value)
  formData.append('description', description)
  const url = `${baseURL}/voice-command/create`
  try {
    // add API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

const UpdateVoiceCommandApi = async (
  id:number,
  website_id: string,
  command_title: string,
  description: string,
  command_value: string,
  accessToken?: string // access token
): Promise<any> => {
    
  const formData = new FormData();
  formData.append('website_id', website_id)
  formData.append('command_title', command_title)
  formData.append('command_value', command_value)
  formData.append('description', description)
  const url = `${baseURL}/voice-command/update/${id}`
  try {
    // add API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

const deleteVoiceCommandApi = async (
    accessToken: string, // access token
    defaultId: number
): Promise<any> => {
    
  const formData = new FormData();
  const url = `${baseURL}/voice-command/destroy/${defaultId}`
  try {
    // delete API
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: "Bearer " + accessToken,
      },
      body: formData,
    });
    return await response.json();
  } catch (error) {
    return Promise.reject;
  }
};

export { getVoiceCommandApi, AddVoiceCommandApi, deleteVoiceCommandApi, UpdateVoiceCommandApi }